import React, {LabelHTMLAttributes} from 'react'
import {StyledLabel} from '@components/ui/Label/style.ts'

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    children: React.ReactNode
    htmlFor?: string
}

const Label = ({children, htmlFor}: LabelProps) => <StyledLabel htmlFor={htmlFor}>{children}</StyledLabel>

export default Label

Label.displayName = 'Label'
